import { useEffect } from "react";

export default function Toast({ message, onClose }) {
  useEffect(() => {
    const t = setTimeout(onClose, 3000);
    return () => clearTimeout(t);
  }, [onClose]);

  return (
    <div style={{ position: 'fixed', bottom: 40, left: '50%', transform: 'translateX(-50%)', background: '#111111', color: '#ffffff', padding: '12px 20px', borderRadius: 12, fontSize: 15, fontWeight: 600, zIndex: 999, animation: 'fadeInUp .2s ease', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: 10 }}>
      <span>{message}</span>
      <button onClick={onClose} style={{ background: 'rgba(255,255,255,0.2)', border: 'none', color: '#ffffff', borderRadius: 8, padding: '2px 8px', cursor: 'pointer', fontSize: 13 }}>닫기</button>
    </div>
  );
}